import { NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";

export interface ICalendarUtils {
  getDateToPickerDate(today?: Date): NgbDateStruct;
  getDateToPickerTime(now?: Date): NgbTimeStruct;
  getStructHoursToDate(hours: NgbTimeStruct, date?: NgbDateStruct): Date;
  dateStructToDate(dateStruct: NgbDateStruct): Date;
  formatMXDate(date?: Date): string;
  convertToLocalDate(dateStr: string | Date): Date;
  formatDateToYYYYMMDD(date: Date): string;
  FormatDateYYYYMMDDToDDMMYYYY(date: string): string;
}

export const calendarUtils: ICalendarUtils = {
  getDateToPickerDate(today: Date = new Date()): NgbDateStruct {
    return {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate(),
    };
  },
  getDateToPickerTime(now: Date = new Date()): NgbTimeStruct {
    return {
      hour: now.getHours(),
      minute: now.getMinutes(),
      second: now.getSeconds(),
    };
  },
  getStructHoursToDate(
    hours: NgbTimeStruct,
    date: NgbDateStruct = calendarUtils.getDateToPickerDate()
  ): Date {
    return new Date(
      date.year,
      date.month - 1,
      date.day,
      hours.hour,
      hours.minute,
      hours.second
    );
  },
  dateStructToDate(dateStruct: NgbDateStruct): Date {
    return new Date(dateStruct.year, dateStruct.month - 1, dateStruct.day);
  },
  formatMXDate(date: Date = new Date()): string {
    return date.toLocaleString("es-MX", { timeZone: "America/Mexico_City" });
  },
  convertToLocalDate(dateStr: string | Date): Date {
    const utcDate =
      typeof dateStr === "string"
        ? new Date(dateStr)
        : new Date(dateStr.getTime());
    // Conversion a Milisegundos
    const offset = utcDate.getTimezoneOffset() * 60000;
    return new Date(utcDate.getTime() - offset);
  },
  formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  },

  FormatDateYYYYMMDDToDDMMYYYY(date: string) {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  },
};
